// extracted by mini-css-extract-plugin
export var button = "_9s-0";
export var icon = "_9s-1";